import { useState } from "react";
import { HeatMapChart } from "../../../components/charts/HeatMapChart";
import StatisticsPeriodToggle from "./StatisticsPeriodToggle";

const QualityHeatMapSection = ({
  title,
  subtitle,
  anomalies,
  currentPage,
  weeksPerPage,
  setTotalPages,
  setWeeksPageLabel,
  setCurrentPage,
  totalPages,
  weeksPageLabel,
  fixedViewMode,
  t,
}) => {
  const [periodMode, setPeriodMode] = useState("month");
  const viewMode = fixedViewMode || (periodMode === "week" ? "week" : "month");

  return (
    <article className="statistics-card min-lg:flex-1 min-lg:min-w-0">
      <div className="dashboard-chart-heading dashboard-chart-heading-row">
        <div className="dashboard-chart-heading-text">
          <h5 className="dashboard-chart-title">{title}</h5>
          {subtitle ? (
            <p className="dashboard-chart-subtitle">{subtitle}</p>
          ) : null}
        </div>
        {fixedViewMode ? null : (
          <StatisticsPeriodToggle
            activeMode={periodMode}
            onModeChange={(mode) => {
              setPeriodMode(mode);
              setCurrentPage(0);
            }}
            t={t}
          />
        )}
      </div>

      {viewMode === "week" && totalPages > 1 && (
        <div className="flex justify-center items-center gap-4 h-10 mb-2">
          <button
            type="button"
            className="px-3 py-1 bg-gray-100 rounded-full"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
            disabled={currentPage === 0}
          >
            <i
              className={`fas fa-chevron-left ${currentPage === 0 ? "text-gray-300" : ""}`}
            />
          </button>
          <span className="text-sm text-gray-600">{weeksPageLabel}</span>
          <button
            type="button"
            className="px-3 py-1 bg-gray-100 rounded-full"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))
            }
            disabled={currentPage >= totalPages - 1}
          >
            <i
              className={`fas fa-chevron-right ${currentPage >= totalPages - 1 ? "text-gray-300" : ""}`}
            />
          </button>
        </div>
      )}

      <div className="relative w-full h-[320px]">
        <div className="absolute inset-0">
          <HeatMapChart
            anomalies={anomalies}
            viewMode={viewMode}
            currentPage={currentPage}
            weeksPerPage={weeksPerPage}
            setTotalPages={setTotalPages}
            setWeeksPageLabel={setWeeksPageLabel}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>

      <div className="flex flex-row items-center justify-center gap-2 mt-2 text-sm text-gray-500">
        <span>{t("Low")}</span>
        <div className="flex flex-row">
          {[
            "#FCEBCF",
            "#F6D79B",
            "#E0AE5B",
            "#B77F2E",
            "#7A4E15",
            "#3D2708",
          ].map((color) => (
            <span
              key={color}
              className="w-6 h-4 first:rounded-l-md last:rounded-r-md"
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
        <span>{t("Very high")}</span>
      </div>
    </article>
  );
};

export default QualityHeatMapSection;
